import PickUpPageContainer from './PickUpPageContainer';

export default PickUpPageContainer;



// WEBPACK FOOTER //
// ./src/components/pages/PickUpPage/index.js